import React from "react";
import { FormField, CardSection } from "../../Common/FormComponents";

const PropertyBasicInfoSection = ({
  formData,
  handleInputChange,
  isCreateMode,
  isMultiUnitBuilding,
  getStatusOptions,
}) => (
  <CardSection title="Basic Information">
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "0.75rem" }}>
      <FormField
        label="Property Type"
        name="type"
        type="select"
        value={formData.type}
        onChange={handleInputChange}
        required
        disabled={!isCreateMode}
        options={[
          { value: "one_time_rental", label: "One Time Rental" },
          { value: "property_management", label: "Property Management" },
          { value: "sale", label: "Sale" },
          { value: "multi_unit_building", label: "Multi-Unit Building" },
        ]}
      />
      <FormField
        label="Status"
        name="status"
        type="select"
        value={formData.status}
        onChange={handleInputChange}
        required
        options={getStatusOptions()}
      />
      <div style={{ gridColumn: "1 / -1" }}>
        {isMultiUnitBuilding ? (
          <FormField
            label="Building Name"
            name="buildingName"
            value={formData.buildingName}
            onChange={handleInputChange}
            required
            placeholder="Enter building name"
          />
        ) : (
          <FormField
            label="Property Title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            required
            placeholder="Enter property title"
          />
        )}
      </div>
      {!isMultiUnitBuilding && (
        <div style={{ gridColumn: "1 / -1" }}>
          <FormField
            label="Description"
            name="description"
            as="textarea"
            rows={3}
            value={formData.description}
            onChange={handleInputChange}
            required
            placeholder="Enter property description..."
            className="mb-0"
          />
        </div>
      )}
    </div>
  </CardSection>
);

export default PropertyBasicInfoSection;
